import {
    BaixarExtratoIrpfPDFService,
    BaixarExtratoPDFService,
    BaixarExtratoPDFViaContaService,
} from "../../../Services/Cobranca/Extrato/ExtratoServices";
import {
    IExtrato,
    IExtratoIR,
} from "../../../Interfaces/Cobranca/Extrato/ExtratoInterface";
import { Controller } from "../../Controller";

export async function BaixarExtratoPDFController(requestBody: IExtrato) {
    return Controller(BaixarExtratoPDFService(requestBody));
}

export async function BaixarExtratoPDFViaContaController(
    requestBody: IExtrato,
    ID_CONTA: number,
    idTipoCaso: number,
    ID_CASO: number
) {
    return Controller(
        BaixarExtratoPDFViaContaService(
            requestBody,
            ID_CONTA,
            idTipoCaso,
            ID_CASO
        )
    );
}

export async function BaixarExtratoIrpfPDFController(requestBody: IExtratoIR) {
    return Controller(BaixarExtratoIrpfPDFService(requestBody));
}
